import { React, useAppI18N } from '@/app'
import { Button } from '@/components'
import { APIClient } from '@/services'
import { AnyFunction } from '@codeleap/types'

export const LoginButton = React.memo((props: { onLeave?: AnyFunction }) => {
  const { t } = useAppI18N()

  const onPress = () => {
    APIClient.UnknownProfile.maybeOpenRegistrationWall()
    props.onLeave?.()
  }

  return <Button variants={['fullWidth']} text={t('login')} debugName={`Modal done continue`} onPress={onPress} />
})
